import { render, staticRenderFns } from "./logDetail.vue?vue&type=template&id=b8f8f2e4&scoped=true&"
import script from "./logDetail.vue?vue&type=script&lang=js&"
export * from "./logDetail.vue?vue&type=script&lang=js&"
import style0 from "./logDetail.vue?vue&type=style&index=0&id=b8f8f2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f8f2e4",
  null
  
)

export default component.exports